import { createFileRoute, notFound, Link } from "@tanstack/react-router";
import LandingPage from "@/components/landing/LandingPage";
import { getLandingPagePreview } from "@/lib/landing-pages.functions";

export const Route = createFileRoute("/preview/$slug")({
  loader: async ({ params }) => {
    try {
      const page = await getLandingPagePreview({ data: { slug: params.slug } });
      if (!page) throw notFound();
      return page;
    } catch (err: any) {
      if (err?.message === "UNAUTHORIZED") {
        throw notFound();
      }
      throw err;
    }
  },
  head: ({ loaderData }) => ({
    meta: [
      {
        title: loaderData
          ? `[Preview] ${loaderData.title}`
          : "Preview | Selectus RH",
      },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  notFoundComponent: () => (
    <div className="flex min-h-screen items-center justify-center bg-background px-4">
      <div className="max-w-md text-center">
        <h1 className="text-3xl font-bold">Preview indisponível</h1>
        <p className="mt-2 text-sm text-muted-foreground">
          Página não encontrada ou você não está autenticado no painel.
        </p>
        <div className="mt-6">
          <Link
            to="/painel"
            className="inline-flex items-center justify-center rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground hover:bg-primary/90"
          >
            Ir para o painel
          </Link>
        </div>
      </div>
    </div>
  ),
  errorComponent: ({ error }) => (
    <div className="flex min-h-screen items-center justify-center bg-background px-4">
      <div className="max-w-md text-center">
        <h1 className="text-2xl font-bold">Erro no preview</h1>
        <p className="mt-2 text-sm text-muted-foreground">
          {error?.message ?? "Erro desconhecido"}
        </p>
      </div>
    </div>
  ),
  component: PreviewRoute,
});

function PreviewRoute() {
  const page = Route.useLoaderData();
  return (
    <div>
      <div className="sticky top-0 z-50 flex items-center justify-between gap-4 bg-amber-500 px-4 py-2 text-sm text-amber-950 shadow">
        <div className="flex items-center gap-2">
          <span className="inline-flex items-center rounded bg-amber-950/10 px-2 py-0.5 text-xs font-bold uppercase tracking-wide">
            Preview
          </span>
          <span className="font-medium">
            {page.slug}
          </span>
          <span className="text-xs opacity-80">
            · {page.published ? "Publicado" : "Rascunho"}
          </span>
        </div>
        <Link
          to="/painel"
          className="rounded-md border border-amber-950/30 bg-white/40 px-3 py-1 text-xs font-medium hover:bg-white/60"
        >
          Sair do preview
        </Link>
      </div>
      <LandingPage pageData={page} />
    </div>
  );
}